<template>
  <v-snackbar
    v-model="appStore.toast.open"
    class="toast"
    :class="`toast--${appStore.toast.type}`"
    location="bottom right"
    :timeout="appStore.toast.timeout"
  >
    {{ appStore.toast.message }}

    <template #actions>
      <v-btn
        density="comfortable"
        icon="mdi-close"
        variant="text"
        @click="closeToast"
      />
    </template>
  </v-snackbar>
</template>

<script setup>
import { appStore, closeToast } from '../store/appStore'
</script>

<style
  scoped
  lang="scss"
>
.toast {
  :deep(.v-snackbar__wrapper) {
    border: 1px solid var(--color-border);
    border-radius: 8px;
    background: var(--color-white);
    box-shadow: var(--shadow-card);
  }

  :deep(.v-snackbar__content) {
    color: var(--color-black);
    font-size: clamp-bp("sm", "xl", 13, 14);
    font-weight: 500;
    line-height: clamp-bp("sm", "xl", 20, 22);
  }

  :deep(.v-snackbar__actions) {
    color: inherit;
  }

  &--success {

    :deep(.v-snackbar__content),
    :deep(.v-snackbar__actions) {
      color: var(--color-success);
    }
  }

  &--error {

    :deep(.v-snackbar__content),
    :deep(.v-snackbar__actions) {
      color: var(--color-danger);
    }
  }
}
</style>
